export default "__VITE_ASSET__f03c2b6b__"